<template>
    <v-menu
        ref="dateRangeMenu"
        v-model="dateRangeMenu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="290px"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="modelDisplay"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                dense
                persistent-hint
                :hint="hint"
            >
            </v-text-field>
        </template>
        <v-card>
            <v-card-text>
                <v-row class="pa-2">
                    <v-col cols="6">
                        <v-text-field
                            v-model="computedDateRange[0]"
                            type="date"
                            label="Start Date"
                            prepend-icon="mdi-calendar"
                            dense
                            persistent-hint
                            hint="Input the start date: MM/DD/YYYY"
                        >
                        </v-text-field>
                    </v-col>

                    <v-col cols="6">
                        <v-text-field
                            v-model="computedDateRange[1]"
                            label="End Date"
                            type="date"
                            prepend-icon="mdi-calendar"
                            dense
                            persistent-hint
                            hint="Input the end date: MM/DD/YYYY"
                        >
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-date-picker
                            v-model="computedDateRange"
                            :label="label"
                            :hint="hint"
                            :color="color"
                            range
                            scrollable
                            :min="min"
                            :max="max"
                            width="30vw"
                        >
                        </v-date-picker>
                    </v-col>
                </v-row>
                <slot></slot>
            </v-card-text>
        </v-card>
    </v-menu>
</template>

<script>
export default {
    name: 'DateRangeMenu',
    props: {
        label: {
            type: String,
            default: 'Date'
        },
        hint: {
            type: String,
            default: 'Select a date'
        },
        color: {
            type: String,
            default: 'info'
        },
        min: {
            type: String,
            default: new Date(
                new Date().setFullYear(new Date().getFullYear() - 5)
            )
                .toISOString()
                .split('T')[0]
        },
        max: {
            type: String,
            default: new Date(
                new Date().setFullYear(new Date().getFullYear() + 5)
            )
                .toISOString()
                .split('T')[0]
        },
        dateRange: {
            type: Array,
            default: () => ['', ''] // Default value for the date range
        }
    },
    data() {
        return {
            dateRangeMenu: false,
            modelDisplay: 'Select a date range'
        };
    },
    computed: {
        // Computed property that reads the dateRange prop and updates the parent when set
        computedDateRange: {
            get() {
                return this.dateRange;
            },
            set(newRange) {
                this.$emit('update:dateRange', newRange);
                this.updateModelDisplay(newRange);
            }
        }
    },
    methods: {
        // Method to format and update the model display string
        updateModelDisplay(range) {
            const [start, end] = range;
            if (start && end) {
                this.modelDisplay = `${start} ~ ${end}`;
            } else {
                this.modelDisplay = 'Select a date range';
            }
        }
    },
    watch: {
        // Watch to update the model display when dateRange prop changes
        dateRange(newRange) {
            this.updateModelDisplay(newRange);
        }
    },
    mounted() {
        // Initialize modelDisplay with the initial date range
        this.updateModelDisplay(this.dateRange);
    }
};
</script>
